/**
 * Shim to restore React.PropTypes for legacy packages that access it directly.
 * React.PropTypes was removed in React 16, but many older packages (react-bootstrap-table,
 * react-scroll-pagination, react-popper, etc.) still reference it.
 * 
 * This must be imported BEFORE any component that uses these legacy packages.
 */
import React from 'react';
import PropTypes from 'prop-types';

if (!React.PropTypes) {
  React.PropTypes = PropTypes;
}

if (!React.createClass) {
  // Provide a minimal createClass shim for packages that still use it
  React.createClass = function(spec) {
    class CreatedClass extends React.Component {
      constructor(props) {
        super(props);
        if (spec.getInitialState) {
          this.state = spec.getInitialState.call(this);
        }
        // Bind all non-lifecycle methods
        Object.keys(spec).forEach(key => {
          if (typeof spec[key] === 'function' && key !== 'render' && 
              key !== 'getInitialState' && key !== 'constructor') {
            this[key] = spec[key].bind(this);
          }
        });
      }
    }
    // Copy all spec methods to prototype
    Object.keys(spec).forEach(key => {
      if (key !== 'getInitialState' && key !== 'propTypes' && key !== 'getDefaultProps') {
        CreatedClass.prototype[key] = spec[key];
      }
    });
    if (spec.propTypes) {
      CreatedClass.propTypes = spec.propTypes;
    }
    if (spec.getDefaultProps) {
      CreatedClass.defaultProps = spec.getDefaultProps();
    }
    if (spec.displayName) {
      CreatedClass.displayName = spec.displayName;
    }
    return CreatedClass;
  };
}
